export const PLAN_SEAT_LIMITS = {
  free: 1,
  solo: 1,
  design_partner: 1,
  team: 5,
  enterprise: 999,
};

export const PLAN_PROJECT_LIMITS = {
  free: 2,
  solo: 15,
  design_partner: 15,
  team: 50,
  enterprise: null,
};

export const PLAN_FEATURES = {
  free: [
    "time_tracking",
    "expense_logging",
    "basic_budgeting",
    "limited_projects",
    "dashboard_access",
  ],
  solo: [
    "time_tracking",
    "expense_logging",
    "basic_budgeting",
    "dashboard_access",
    "dashboard_rollups",
    "real_time_forecasting",
    "basic_analytics",
    "exports",
  ],
  team: [
    "time_tracking",
    "expense_logging",
    "basic_budgeting",
    "dashboard_access",
    "dashboard_rollups",
    "real_time_forecasting",
    "basic_analytics",
    "full_analytics",
    "multi_user_dashboards",
    "program_access",
    "portfolio_access",
    "margin_drift_alerts",
    "team_seats",
    "collaboration",
    "alerts",
    "exports",
    "full_exports",
  ],
  design_partner: [
    "time_tracking",
    "expense_logging",
    "basic_budgeting",
    "dashboard_access",
    "dashboard_rollups",
    "real_time_forecasting",
    "basic_analytics",
    "full_analytics",
    "multi_user_dashboards",
    "program_access",
    "portfolio_access",
    "margin_drift_alerts",
    "team_seats",
    "collaboration",
    "alerts",
    "exports",
    "full_exports",
  ],
  enterprise: [
    "all_team_features",
    "custom_integrations",
    "sso",
    "audit_logs",
    "admin_controls",
    "dedicated_support",
    "dashboard_access",
  ],
};

/**
 * Resolves the canonical plan for a user.
 * Legacy plan names are normalised to the current launch plan set.
 */
export function resolvePlan(user) {
  if (!user) return "free";
  if (user.role === "SUPER_ADMIN") return "enterprise";

  const rawPlan =
    user?.organization_effective_plan ??
    user?.organization_access_tier ??
    user?.organization_plan ??
    user?.organization?.effective_plan ??
    user?.organization?.access_tier ??
    user?.organization?.plan ??
    user?.subscription_plan ??
    "free";
  const raw = String(rawPlan).toLowerCase();

  if (raw === "starter") return "solo";
  if (["pro", "premium", "growth"].includes(raw)) return "team";
  return PLAN_FEATURES[raw] ? raw : "free";
}

export function hasFeature(user, featureKey) {
  const planId = resolvePlan(user);
  const features = PLAN_FEATURES[planId] || [];
  return (
    features.includes("all_team_features") ||
    features.includes(featureKey)
  );
}

export function hasForecastAccess(user) {
  return hasFeature(user, "real_time_forecasting");
}

export function hasFeatureAccessByPlan(planId, featureKey) {
  const canonical =
    planId === "starter" ? "solo" : ["pro", "premium", "growth"].includes(planId) ? "team" : planId;
  const features = PLAN_FEATURES[canonical] || [];
  return (
    features.includes("all_team_features") ||
    features.includes(featureKey)
  );
}

export function getPlanRules(planId) {
  const canonical =
    planId === "starter" ? "solo" : ["pro", "premium", "growth"].includes(planId) ? "team" : planId;
  return {
    seatLimit: PLAN_SEAT_LIMITS[canonical] || 1,
    projectLimit: PLAN_PROJECT_LIMITS[canonical] ?? null,
    features: PLAN_FEATURES[canonical] || [],
    hasFeature: (feature) => hasFeatureAccessByPlan(canonical, feature),
    canAddUser: (currentUserCount) => {
      const limit = PLAN_SEAT_LIMITS[canonical] || 1;
      return currentUserCount < limit;
    },
  };
}
